import axios from 'axios';
import pick from 'lodash/pick';
/* istanbul ignore file */

export const getTsAndCs = () =>
  axios.post('/authentication/termsAndConditions/getTsAndCs', {}).then(({ data }) => data);

export const emailTsAndCs = (body) => {
  const postData = pick(body, [
    'customerCode',
    'termsConditionsId',
    'termsConditionsName',
    'userCode'
  ]);
  return axios
    .post('/authentication/termsAndConditions/emailTsAndCs', postData)
    .then(({ data }) => data);
};

export const acceptTsAndCs = (body) => {
  const postData = pick(body, [
    'customerCode',
    'termsConditionsId',
    'termsConditionsName',
    'userCode'
  ]);

  return axios
    .post('/authentication/termsAndConditions/acceptTsAndCs', postData)
    .then(({ data }) => data);
};

export const declineTsAndCs = (body) => {
  const postData = pick(body, [
    'customerCode',
    'termsConditionsId',
    'termsConditionsName',
    'userCode'
  ]);
  return axios
    .post('/authentication/termsAndConditions/declineTsAndCs', postData)
    .then(({ data }) => data);
};
